import { render, staticRenderFns } from "./linkedform.vue?vue&type=template&id=18b7de3d&scoped=true"
import script from "./linkedform.vue?vue&type=script&lang=js"
export * from "./linkedform.vue?vue&type=script&lang=js"
import style0 from "./linkedform.vue?vue&type=style&index=0&id=18b7de3d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b7de3d",
  null
  
)

export default component.exports